import { render } from "./DiscoverProperties.vue?vue&type=template&id=73eea17e&ts=true"
import script from "./DiscoverProperties.vue?vue&type=script&lang=ts"
export * from "./DiscoverProperties.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__